<template>
  <svg :width="`${size}px`" :height="`${size}px`" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>AEB3BD4A-C9B6-4A4D-AB84-DDBD0FFC25AF</title>
    <defs>
      <filter id="filter-1">
        <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"></feColorMatrix>
      </filter>
      <polygon id="path-2" points="14 1.4 12.6 0 7 5.6 1.4 0 0 1.4 5.6 7 0 12.6 1.4 14 7 8.4 12.6 14 14 12.6 8.4 7"></polygon>
    </defs>
    <g id="Apps" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="Dashboard---Freelance-Tasks---Pending" transform="translate(-1030.000000, -442.000000)">
        <g id="List" transform="translate(370.000000, 374.000000)">
          <g id="Molecules/Task/Log" transform="translate(0.000000, 60.000000)">
            <g id="Atoms/Form/Checkbox/State" transform="translate(660.000000, 8.000000)">
              <g filter="url(#filter-1)" id="Variables/Icon/Play">
                <g id="Group" transform="translate(9.000000, 9.000000)">
                  <mask id="mask-3" fill="white">
                    <use xlink:href="#path-2"></use>
                  </mask>
                  <g id="Mask"></g>
                  <g id="↳-🎨Color" mask="url(#mask-3)" fill="#19191D">
                    <g transform="translate(-9.000000, -9.000000)" id="Color">
                      <rect x="0" y="0" width="32" height="32"></rect>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'CrossIcon',

  props: {
    size: {
      required: false,
      default: 32
    }
  }
};
</script>

<style scoped>

</style>
